import { render } from "./SaveStatus.vue?vue&type=template&id=55345a52"
import script from "./SaveStatus.vue?vue&type=script&lang=js"
export * from "./SaveStatus.vue?vue&type=script&lang=js"

import "./SaveStatus.vue?vue&type=style&index=0&id=55345a52&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__